<template>
  <div  class="fixed top-0 right-0 bg-white w-full h-full z-50">
    <div v-for="(item,index) in 2" :key="index" class="w-11/12 mx-auto mb-2">
      <div class="border-2 border-dashed border-black p-4">
        <div class="flex items-center justify-between">
          <span></span>
          <h1 class="text-center" style="font-size: 25px;">
            حواله بارگیری ({{ remittanceDetail.productTitle }})
          </h1>
          <img src="@/assets/bargram.png" width="90" />
        </div>
        <v-row class="justify-between">
          <v-col cols="5">
            <div class="mt-5 border">
              <!-- <span class="inline-block border-b border-black">شرکت / آقا محترم</span> -->
              <div class="flex flex-col items-start px-2 my-3">
                <div class="ml-5">
                  <span class="ml-2">فرستنده :</span>
                  <span>{{ remittanceDetail.senderDetailNameFamily }}</span>
                </div>
                <div class="ml-5">
                  <span class="ml-2">کدملی فرستنده :</span>
                  <span>{{ remittanceDetail.senderDetailNationalId }}</span>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="5">
            <div class="mt-5 border">
              <!-- <span class="inline-block border-b border-black">شرکت / آقا محترم</span> -->
              <div class="flex flex-col items-start px-2 my-3">
                <div class="ml-5">
                  <span class="ml-2"> گیرنده :</span>
                  <span>{{ remittanceDetail.receiverDetailNameFamily }}</span>
                </div>
                <div class="ml-5">
                  <span class="ml-2">کدملی گیرنده :</span>
                  <span>{{ remittanceDetail.receiverDetailNationalId }}</span>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="2">
            <div class="mt-5 border h-[75px] flex justify-center flex-col items-center">
              <!-- <span class="inline-block border-b border-black">شرکت / آقا محترم</span> -->
                 <span>وزن :</span>
                <span style="font-size: 20px;">{{ remittanceDetail.weight }} </span>
             
              <span>کیلوگرم</span>
            </div>
          </v-col>
        </v-row>
        <div class="mt-5">
          <span class="">احتراما خواهشمند است نسبت به بارگیری ناوگان زیل اقدام گردد .</span>
          <table class="mt-5 w-full">
            <tr class="border-b border-black pb-3">
              <th class="text-center">پلاک</th>
              <th class="text-center">نوع ناوگان</th>
              <th class="text-center">راننده</th>
              <th class="text-center">هوشمند ماشین</th>
              <th class="text-center">تلفن</th>
              <th class="text-center">کدملی راننده</th>
            </tr>
            <tbody>
              <tr>
                <td class="text-center py-3">
                  <plaque class="mx-auto" :plaque="remittanceDetail.plaque" />
                </td>
                <td class="text-center py-3" style="font-weight: 800; font-size: 15px;">
                  {{ remittanceDetail.carTypeTitle }}
                </td>
                <td class="text-center py-3" style="font-weight: 800; font-size: 15px;">
                  {{
                    `${remittanceDetail.driver?.name} ${remittanceDetail.driver?.family}`
                  }}
                </td>
                <td class="text-center py-3" style="font-weight: 800; font-size: 15px;">
                  {{
                    `${remittanceDetail.car?.smartIdCar} `
                  }}
                </td>
                <td class="text-center py-3" style="font-weight: 800; font-size: 15px;">
                  {{ remittanceDetail.driver?.mobile }}
                </td>
                <td class="text-center py-3" style="font-weight: 800; font-size: 15px;">
                  {{
                    remittanceDetail.driver?.nationalId ||
                    remittanceDetail.nationalId
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-5">
          <div class="flex items-center">
            <span class="block">آدرس بارگیری: </span>
            <span class="block mr-1">{{
              remittanceDetail.loadingAddress
            }}</span>
          </div>
        </div>
        <div class="mt-5">
          <div class="flex items-center justify-center">
            <!-- <span class="">آدرس تخلیه : </span> -->
            <span class="block mr-1">آدرس تخلیه : {{
              remittanceDetail.destination_province?.title ||
              remittanceDetail.destination_city?.title ||
              remittanceDetail.province?.title
            }} - {{ remittanceDetail.dischargeAddress }}</span>
            <!-- <span class="block mx-1">-</span>
            <span class="block">{{ remittanceDetail.dischargeAddress }}</span> -->
          </div>
        </div>
        <!-- <h5 class="mr-auto w-max mt-5">با تشکر فراوان</h5> -->

        <div class="mt-5">
          <table class="mt-5 w-full">
            <tr class="border-b border-black pb-3">
              <th class="text-center">تاریخ</th>
              <th class="text-center">اعتبار حواله</th>
              <th class="text-center">شماره حواله</th>
              <th class="text-center">کد اعلام بار</th>
              <th class="text-center">شرکت حمل و نقل</th>
            </tr>
            <tbody>
              <tr>
                <td class="text-center py-3" style="font-weight: 800; font-size: 16px;">
                  {{ getPersianDate(remittanceDetail.created_at) }}
                </td>
                <td class="text-center py-3" style="font-weight: 800; font-size: 16px;">
                  {{ getPersianDateOnly(remittanceDetail.created_at) }}
                </td>
                <td class="text-center py-3" style="font-weight: 800; font-size: 16px;">{{ remittanceDetail.id }}</td>
                <td class="text-center py-3" style="font-weight: 800; font-size: 16px;">
                  {{
                    remittanceDetail.order_id ||
                    remittanceDetail.orderHistory_id
                  }}
                </td>
                <td class="text-center py-3 " style="font-weight: 800; font-size: 18px;">
                  {{
                    remittanceDetail.company_name ||
                    remittanceDetail.company?.company_name
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import Plaque from "@/components/Plaque.vue";

export default {
  components: { Plaque },
  props: ["remittanceDetail"],
  data() {
    return {};
  },
};
</script>

<style>
</style>